import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'
import { useDispatch } from 'react-redux'

import styles from './styles.module.scss'

import { addSnackbar, dismissSnackbar } from '../../../store/settings/actions'
import { updatePlace } from '../../../api'

import ArrowUpIcon from '../../Icons/ArrowUpIcon'
import NoteIcon from '../../Icons/NoteIcon'

const PlaceDescription = ({description: initialDescription, canManage, companyId, placeId, onUpdated}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [description, setDescription] = useState(initialDescription)
  const textareaRef = useRef(null)

  useEffect(() => {
    if (!textareaRef.current) return
    textareaRef.current.style.height = 'auto'
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
  }, [description])

  const handleChangeDescription = (e) => {
    setDescription(e.target.value)
  }

  const handleSubmit = async () => {
    if (description === initialDescription) {
      return
    }
    onUpdated(placeId, description)
    const res = await updatePlace(companyId, placeId, {folder_description: description})
    if (res) {
      dispatch(addSnackbar(t('Description was updated'), 'success'))
      setTimeout(() => {
        dispatch(dismissSnackbar())
      }, 2000)
      return
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>{t('description')}</div>
        <div className={styles.description}></div>
      </div>
      <div>
        <div className={styles.sectionTitle}>{t('description')}</div>
        {
          canManage
            ? <div className={styles.inputContainer}>
                <textarea
                  ref={textareaRef}
                  rows={1}
                  value={description}
                  className={styles.input}
                  placeholder={t('Leave a description')}
                  onChange={handleChangeDescription} />
                <div className={cn(styles.submitButton, {[styles.active]: description !== initialDescription})} onClick={handleSubmit}>
                  <ArrowUpIcon />
                </div>
              </div>
            : <div className={styles.descriptionContainer}>
                <NoteIcon style={{marginTop: 4}} color="#6100FF" />
                <div>{ description }</div>
              </div>
        }
        
      </div>
    </div>
  )
}

export default PlaceDescription
